import { createFileRoute } from '@tanstack/react-router';

export interface Search {
  locationId?: string;
}

/**
 * This is a LEGACY route!
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/submissions/inbox/needs-review/$submissionId')({
  staticData: { team: 'forms' },
  validateSearch: (search: Search): Search => {
    return {
      locationId: search.locationId,
    };
  },
});
